module.exports = __webpack_public_path__ + "img/img1.3f45b450.jpg";